<template>
    <page>
        <module :title="verify ? '会员认证审核' : '会员认证详情'">
            <div>
                <c-detail title="基础信息">
                    <c-detail-item label="会员" >
                        {{detailData.user_manage_mobilephone}}
                        <span v-if="detailData.nick_name && detailData.nick_name!=''">({{detailData.nick_name}})</span>
                    </c-detail-item>
                    <c-detail-item label="状态" >
                        <span v-if="detailData.state == 0" style="color:#999">待审核</span>
                        <span v-if="detailData.state == 1" style="color:green">审核通过</span>
                        <span v-if="detailData.state == 2" style="color:red">审核驳回</span>
                    </c-detail-item>
                    <c-detail-item label="真实姓名">
                        {{detailData.user_realname}}
                    </c-detail-item>
                    <c-detail-item label="证件号码">
                        {{detailData.idcardno}}
                    </c-detail-item>
                    <c-detail-item label="证件照片">
                      <div  class="flex-center-cross">
                        <c-image v-for="(medias, j) in detailData.idcard_img_arr" :key="j" class="img" :src="medias" size="120" preview></c-image>
                      </div>
                    </c-detail-item>
                    <c-detail-item label="认证时间">
                        {{detailData.update_date}}
                    </c-detail-item>
                    <c-detail-item label="审核人">
                      {{detailData.approval_user_realname||'--'}}
                    </c-detail-item>
                    <c-detail-item label="审核时间">
                      {{detailData.approval_date||'--'}}
                    </c-detail-item>
                    <c-detail-item  v-if="detailData.state ==2" label="驳回原因" full>
                      <span style="color:red"> {{detailData.rejected_reason}}</span>
                    </c-detail-item>
                </c-detail>
            </div>

            <template v-if="verify" slot="button">
                <c-button size="m" @click="verifyHandle(1)">审核通过</c-button>
                <c-button size="m" color="red" @click="verifyHandle(2)">审核驳回</c-button>
            </template>
        </module>

        <c-dialog ref="approvalReason" title="驳回原因" width="400" @resolve="approvalHandle">
            <div class="approval-eason">
                <textarea v-model="approvalReason" placeholder="请输入驳回理由..."></textarea>
            </div>
        </c-dialog>
    </page>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'user_auth_detail',

        props: {
            id: String,
            verify: Boolean
        },

        data() {
            return {
                detailData: {},
                approvalReason: ''
            }
        },

        computed: {
            ...mapState(['dict']),
            stateName() {
                return {
                    0: '草稿',
                    1: '待审核',
                    2: '审批通过',
                    '-1': '驳回'
                }[this.detailData.state];
            },
        },

        watch: {
            id() {
                this.getTaskDetail();
            }
        },

        mounted() {
            this.getTaskDetail();
        },

        methods: {
            getTaskDetail() {
                this.request({
                    url: '/platform_user/auth/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.detailData = data;
                    }
                });
            },
            verifyHandle(state) {
                if(state == 2){//驳回
                    this.$refs.approvalReason.open();
                }else{
                    this.$confirm({
                        text: '确定要审批通过吗？',  // 提示内容,
                        buttonName: '确定',  // 确定按钮文字
                        cancelButton: true,  // 是否显示取消按钮
                        resolve: () => {
                            this.request({
                                url: '/platform_user/auth/approval',
                                data: {
                                    id: this.id,
                                    state
                                },
                                loading: true,
                                success: () => {
                                    this.$message({
                                        text: '审核成功'
                                    });
                                    this.$bus.$emit('userAuthList.update');
                                    this.redirectTo('/user_auth_list');
                                }
                            });
                        },  // 确定按钮回调
                        cancel: () => {},  // 取消按钮回调
                    });
                }
            },
            approvalHandle(stop){
                if (!this.approvalReason.trim()) {
                    this.$message({
                        text: '请填写驳回原因'
                    });
                    stop();
                    return;
                }
                this.request({
                  url: '/platform_user/auth/approval',
                    data: {id:this.id,state:2,rejected_reason:this.approvalReason.trim()},
                    loading: true,
                    success: data => {
                        this.$message({
                            text: '驳回成功',
                            icon: 'success'
                        });
                        this.$bus.$emit('userAuthList.update');
                        this.redirectTo('/user_auth_list');
                    }
                });
            },
        }
    }
</script>

<style lang="stylus" scoped>
  .approval-eason {
    padding: 20px;

    textarea {
      box-sizing: border-box;
      width: 100%;
      height: 120px;
      border: none;
      padding: 10px 14px;
      line-height: 20px;
      background: #FAFAFA;
      resize: none;
    }
  }
</style>